var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6537 4.60547H5.67409C4.86208 4.60547 4.20312 5.24893 4.20312 6.04128V23.0942C4.20312 23.8877 4.86208 24.532 5.67409 24.532H22.6537C23.4662 24.532 24.1296 23.8877 24.1296 23.0942V6.04128C24.1296 5.24893 23.4662 4.60547 22.6537 4.60547ZM10.113 21.5856H7.15612V12.0765H10.113V21.5856ZM8.63455 10.7763C8.40949 10.7763 8.18663 10.732 7.97871 10.6458C7.7708 10.5596 7.58189 10.4334 7.4228 10.2742C7.26371 10.115 7.13754 9.92598 7.05152 9.71801C6.96549 9.51003 6.92128 9.28715 6.92143 9.06208C6.92143 8.60777 7.1019 8.17207 7.42315 7.85082C7.7444 7.52957 8.1801 7.3491 8.63442 7.3491C9.08873 7.3491 9.52443 7.52957 9.84568 7.85082C10.1669 8.17207 10.3474 8.60777 10.3474 9.06208C10.3474 9.51649 10.167 9.9523 9.8458 10.2737C9.52462 10.5952 9.08896 10.7759 8.63455 10.7763V10.7763ZM21.1822 21.5856H18.23V16.9615C18.23 15.8584 18.2084 14.44 16.6937 14.44C15.1555 14.44 14.9211 15.6414 14.9211 16.8816V21.5859H11.9667V12.0765H14.8021V13.3751H14.8425C15.2371 12.6278 16.2014 11.8393 17.6394 11.8393C20.63 11.8393 21.1824 13.8082 21.1824 16.3696V21.5856H21.1822Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.065801958a867b06e41de9ff74430079.svg";
export { ForwardRef as ReactComponent };